module.exports = "<div> <div class=\"modal-body\"> {{ vm.text }} </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok()\">OK</button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/dialog/showTooltipTemplate.html
// module id = IPSF
// module chunks = 0